import { AiOutlineLoading } from 'react-icons/ai';

export const LoadingSpinner = () => (
    <AiOutlineLoading
        style={{
            width: '24px',
            height: '24px',
            color: 'grey',
            alignSelf: 'center',
            animation: 'spinicon 1s linear infinite',
        }}
    />
);
